import { ProgressMeasurementService } from "../../services/shared/progress-measurement-service";
import { OnInit, Component } from "@angular/core";

@Component({
    standalone: false,
    selector: "progress-measure",
    templateUrl: "./progressMeasure.component.html",
})
export class ProgressMeasureComponent implements OnInit {
    progressMeasurementService: ProgressMeasurementService;

    constructor(progressMeasurementService: ProgressMeasurementService) {
        this.progressMeasurementService = progressMeasurementService;
    }

    ngOnInit() { }

    isSpinnerVisible(): boolean {
        return this.progressMeasurementService.isOpen();
    }

    hasCancelButton() {
        return this.progressMeasurementService.showCancelButton();
    }

    cancel() {
        this.progressMeasurementService.cancel();
    }
}
